import React, { useState, useEffect } from "react";

import {
  Nav,
  NavList,
  NavItem,
  Dropdown,
  DropdownList,
  DropdownItem,
  MenuToggle,
  Skeleton
} from "@patternfly/react-core";

import { Link, useNavigate } from "react-router-dom";

export default function OrganizationNav({ state, location }) {
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 1000
  );

  const [isOpen, setIsOpen] = useState(false);

  const { isLoadedOrganizationMenu, organizationmenu_data } =
    state;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  // if (!isLoadedOrganizationMenu) {
  //   return (
  //     <span>
  //       <Spinner size="md" />
  //       {" "}Ładowanie menu...
  //     </span>
  //   );
  // }
  if (!isLoadedOrganizationMenu) {
    if (isMobile) {
      return (
        <Skeleton
          width="100px"
          height="36px"
          screenreaderText="Ładowanie menu"
        />
      );
    }

    return (
      <Nav
        variant="horizontal"
        aria-label="Ładowanie menu"
      >
        <NavList>
          <NavItem>
            <Skeleton
              width="110px"
              fontSize="md"
              screenreaderText="Ładowanie menu"
            />
          </NavItem>

          <NavItem>
            <Skeleton
              width="160px"
              fontSize="md"
            />
          </NavItem>

          <NavItem>
            <Skeleton
              width="130px"
              fontSize="md"
            />
          </NavItem>
        </NavList>
      </Nav>
    );
  }

  const org = organizationmenu_data.organization_menu?.[0];

  if (!org) {
    return null;
  }

  const menuItems = [
    {
      key: "home",
      label: "Strona główna",
      path: "/",
    },

    ...Object.entries(
      org.organization_branches || {}
    )
      .filter(
        ([, branch]) =>
          branch.organization_branch_published &&
          branch.organization_branch_theory_results > 0
      )
      .map(([key, branch]) => ({
        key,
        label: branch.organization_branch_name,
        path: `/${org.organization_symbol.toLowerCase()}/${branch.organization_branch_symbol.toLowerCase()}/dashboard`,
      })),
  ];

  if (isMobile) {
    return (
      <Dropdown
        isOpen={isOpen}
        onOpenChange={(open) => setIsOpen(open)}
        toggle={(toggleRef) => (
          <MenuToggle
            ref={toggleRef}
            onClick={() => setIsOpen(!isOpen)}
            isExpanded={isOpen}
          >
            Menu
          </MenuToggle>
        )}
      >
        <DropdownList>
          {menuItems.map((item) => (
            <DropdownItem
              key={item.key}
              onClick={() => {
                navigate(item.path);
                setIsOpen(false);
              }}
            >
              {item.label}
            </DropdownItem>
          ))}
        </DropdownList>
      </Dropdown>
    );
  }

  return (
    <Nav variant="horizontal">
      <NavList>
        {menuItems.map((item) => (
          <NavItem
            key={item.key}
            isActive={
              item.path === "/"
                ? location?.pathname === "/"
                : location?.pathname?.startsWith(
                    item.path.replace(
                      "/dashboard",
                      ""
                    )
                  )
            }
          >
            <Link to={item.path}>
              {item.label}
            </Link>
          </NavItem>
        ))}
      </NavList>
    </Nav>
  );
}